import type { ImpositionNode } from "#internal"

/** Every page node under `node`, in tree order. */
export function* LeafNodes(node: ImpositionNode): Generator<ImpositionNode> {
  if (node.page) {
    yield node
    return
  }
  for (const child of node.children) yield* LeafNodes(child)
}
